import { ecsApi, CreateSecurityAuditPayload, CreateSecurityAuditResponse } from '@services';

export const securityAuditsApi = ecsApi.injectEndpoints({
    endpoints: (builder) => ({
        createSecurityAudit: builder.mutation<CreateSecurityAuditResponse, CreateSecurityAuditPayload>({
            query: (payload) => ({
                url: '/security-audits',
                method: 'POST',
                body: payload
            })
        })
    })
});

export const { useCreateSecurityAuditMutation } = securityAuditsApi;
